import { LogItemLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/LogItemLayout';
import {
  BaseEvent,
  BaseEventProps,
} from '@features/components/ClinicalData/components/ClinicalLog/components/BaseEvent';
import { YesNoChip } from '../components/YesNoChip';

type YesNoProps = {
  value?: boolean;
} & BaseEventProps;

export const YesNoItem = ({ onShareClick, value, shared, event, description }: YesNoProps) => {
  return (
    <LogItemLayout>
      <BaseEvent
        onShareClick={onShareClick}
        event={event}
        shared={shared}
        description={description}
        endContent={<YesNoChip value={value} />}
      />
    </LogItemLayout>
  );
};
